import React from 'react';
import PropTypes from 'prop-types';

import { useRouter } from 'utils';
import useBoundariesSelectService from 'components/maps/Boundaries/service';
import EditMapBoundsList from '.';

const EditMapBoundsListContainer = ({ shapes, renderBoundriesButtons }) => {
  const { pageId } = useRouter();
  const { AddBounds: addBoundaries, RemoveBounds: removeBoundaries } = useBoundariesSelectService(pageId);

  const handleAddBounds = (id) => {
    addBoundaries(id);
  };

  const handleRemoveBounds = (id) => {
    removeBoundaries(id);
  };

  return (
    <EditMapBoundsList
      shapes={shapes}
      renderBoundriesButtons={renderBoundriesButtons}
      handleAddBounds={handleAddBounds}
      handleRemoveBounds={handleRemoveBounds}
    />
  );
};

EditMapBoundsListContainer.propTypes = {
  renderBoundriesButtons: PropTypes.func,
  shapes: PropTypes.array.isRequired,
};

export default EditMapBoundsListContainer;
